const translations = {
  "en": {
    "Hot Crypto": "Hot Crypto",
    "Hot Themes": "Hot Themes"
  },
  "zh-tw": {
    "Hot Crypto": "熱門加密貨幣",
    "Hot Themes": "熱門主題"
  }
};

export default translations;
